<template>
	<dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title> {{ statplace.source_name }} </template>
        <template v-slot:content>
           <div class = 'py-2 text-center'>Удалить источник?</div>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 red--text text--darken-2' :loading = 'indicator' block depressed @click = 'deleteStatplace'>Удалить</v-btn>
        </template>
    </dialog-generic>
</template>

<script>
	import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

	export default {
		name: 'StatplaceDeleteDialog',
		props: ['data', 'postAction', 'projectId', 'initialState'],
		components: {'dialog-generic': DialogGeneric},
		data() {
			return {
				visibility: this.initialState,
				statplace: this.data,
				indicator: false,
			}
		},
		watch: {
			initialState(value) {
	            this.visibility = value
	        },
	        visibility(value) {
	            this.$emit('update:initialState', value);
	        },
	        data(value) {
	        	this.statplace = value
	        }
		},
		methods: {
			deleteStatplace() {
				this.indicator = true;
				let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8'
		        };
		        let requestData = {
		          'login': this.$store.getters.userLogin,
		          'source_id': this.statplace.source_id
		        }
		        this.$http.patch(this.$store.getters.endpoint + '/db/project/' + this.projectId + '/statplaces',
		          requestData,
		          {headers: {...this.$store.state.restrictedHeaders,...requestHeaders}}
		        ).then( (r) => {
					this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'delete',
                            target: 'project_source'
                        },
                        once: false
                    })
		        	this.postAction('statplaces')
		        	this.visibility = false;
		        	this.indicator = false;
		        });
			}
		}
	}
</script>